import common from "./nl.json";
import { nlTranslations as login } from "../../pages/LocalLogin/translations";
import { nlTranslations as paymentMethods } from "../../pages/PaymentMethods/translations";
import { nlTranslations as dashboard } from "../../pages/Dashboard/translations";
import { nlTranslations as invoices } from "../../pages/Invoices/translations";
import { nlTranslations as payInvoices } from "../../pages/PayInvoices/translations";
import { nlTranslations as invoice } from "../../pages/Invoice/translations";
import { nlTranslations as securityDeposit } from "../../pages/SecurityDeposit/translations";

export default {
  common,
  login,
  dashboard,
  paymentMethods,
  invoices,
  payInvoices,
  invoice,
  securityDeposit,
};
